import { ElementMatcher } from './common/ElementMatcher';
const defaultAnchorsOptions = {
    marker: '#'
};
export class Anchor {
    constructor(win = win, options = {}) {
        this.win = win;
        this.doc = this.win.document;
        this.anchoredHeadingsQuery = [...Array(6)]
            .map((_, i) => `[data-anchors]:not([data-anchors=false]) > h${i + 1}, [data-anchors]:not([data-anchors=false]) :not([data-anchors=false]) h${i + 1}`)
            .join(', ');
        this.options = Object.assign({}, defaultAnchorsOptions, options);
        this.defaultMarker = this.options.marker || '#';
    }
    activate() {
        this.doc
            .querySelectorAll(this.anchoredHeadingsQuery)
            .forEach(element => this.updateHeader(element));
    }
    updateHeader(element) {
        this.addAnchorLink(element);
    }
    addAnchorLink(element) {
        const id = element.id;
        if (!id)
            return;
        element.classList.add('anchored');
        const anchor = this.createAnchor(id, element);
        element.appendChild(anchor);
    }
    createAnchor(id, header) {
        const marker = this.getMarker(header);
        const anchor = this.doc.createElement('a');
        anchor.setAttribute('href', `#${id}`);
        anchor.classList.add('anchor-link');
        anchor.innerText = ' ' + marker;
        return anchor;
    }
    getMarker(header) {
        const marker = ElementMatcher.findParentOrSelf(header, '[data-anchors]').dataset.anchors;
        return !marker || marker === 'true' || marker === 'false'
            ? this.defaultMarker
            : marker || this.defaultMarker;
    }
}
